import { render, staticRenderFns } from "./full-sort-up.vue?vue&type=template&id=06d22c1c&"
import script from "./full-sort-up.vue?vue&type=script&lang=js&"
export * from "./full-sort-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06d22c1c')) {
      api.createRecord('06d22c1c', component.options)
    } else {
      api.reload('06d22c1c', component.options)
    }
    module.hot.accept("./full-sort-up.vue?vue&type=template&id=06d22c1c&", function () {
      api.rerender('06d22c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/full-sort-up.vue"
export default component.exports